import { Component, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import * as encoding from 'encoding-japanese';
import { InventoryService } from '../../../service/inventory/inventory.service';
import { InventoryStockService } from '../../../service/inventory-stock/inventory-stock.service';
import { PdfReportService } from '../../../service/pdf-report/pdf-report.service';
import { OwnerService } from '../../../service/owner/owner.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { insertcomma } from '../../../util/util';
import { AgGridHelper } from '../../../util/AgGridHelper';
import { isSingleOwner } from 'app/menu/header/header.component';

@Component({
  selector: 'app-root',
  templateUrl: 'wa7011.component.html',
  styleUrls: ['wa7011.component.scss']
})
export class Wa7011Component implements AfterViewInit {
  private gridApi: any;
  public componentTitle = 'WA7011:棚卸在庫入力';
  public owners: any;
  public ownerId: number = undefined;
  public ownerCd: string;
  public ownerTx: string;
  public inventoryId: number;
  public createDt: Date;
  public inventoryDt: Date;
  public endDt: Date;
  public stinventoryId: number;
  public stinventoryTx: string;
  public updprogramCd = 'WA7011';
  public excelFl = 0;
  public gridOptions: GridOptions;
  public showGrid = false;
  public rowData: any[];
  public working = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  public reporttrnId: number;
  private reportOpened = false;
  private reportTry = 0;
  public viewModes: any[];
  public viewMode = 0;
  private modal1: boolean = false;
  private modal2: boolean = false;
  private isOwnerFixed = false;

  private isShowSendLoading = false;
  private isShowRemoveModal = false;
  public url = '#';

  private INVEN_RANDOM_PROP_NAME = '__index';
  private invenStock = null
  private errorInfo = '';
  private selectedCount = 0;
  private isEnableRightSearchButtons = false;
  private searchOpen: boolean = true;
  @ViewChild('gridView')
  gridView: ElementRef;
  private gridHelper: AgGridHelper;
  private totalCount = 0;
  public gridEditFl = [];
  private isEnableClearFilterButton = false;
  constructor(
    private router: Router,
    private inventoryService: InventoryService,
    private inventoryStockService: InventoryStockService,
    private pdfReportService: PdfReportService,
    private ownerService: OwnerService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {
    this.rowData = [];
    this.gridHelper = new AgGridHelper();
    this.gridOptions = <GridOptions>{
      rowSelection: 'multiple',
      floatingFilter: true,
      enableRangeSelection: true,
      checkboxSelection: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      onColumnResized: this.saveColumnWidth,
      pagination: true,
      shohwLoadingOverlay: true,
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa7011_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
        this.gridHelper.el.nativeElement.querySelector('div.ag-spread .ag-paging-panel').style.display = 'none';
        this.gridHelper.onGridReady();
      },
      onRowDataChanged: () => {
        this.gridHelper.onRowDataChanged();
        this.isEnableRightSearchButtons = false;
        this.errorInfo = '';
        if (this.gridOptions.rowData && this.gridOptions.rowData.length > 0) this.gridHelper.isShowGridNoDataOverlay = false;
        else this.gridHelper.isShowGridNoDataOverlay = true;
      },
      onSelectionChanged: () => {
        this.errorInfo = '';
        this.isEnableRightSearchButtons = this.gridOptions.api.getSelectedRows().length > 0;
        this.selectedCount = this.gridOptions.api.getSelectedRows().length;
      },
      overlayLoadingTemplate: this.gridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelper.TEMPLATE_GRID_NODATA,
      postProcessPopup: params => {
        this.gridHelper.fixedAgMenu();
        this.errorInfo = '';
      },
      onSortChanged: () => {
        this.gridHelper.renderGridCheckboxImage();
        this.errorInfo = '';
      },
      onPaginationChanged: () => {
        this.totalCount = this.gridOptions.api.paginationGetRowCount();
        this.gridHelper.renderScrollArrow();
        this.gridHelper.renderGridCheckboxImage();
      },
      onFilterChanged: () => {
        this.isEnableClearFilterButton = this.gridOptions.api.isAnyFilterPresent();
        this.gridHelper.onGridFilterChanged();
        this.errorInfo = '';
      }
    };
    this.gridOptions.getRowClass = params => {
      if (params.node.rowIndex % 2 === 0) {
        return 'alternative-row-style';
      }
    };
    this.gridOptions.columnDefs = [
      {
        headerName: '',
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        width: 30,
        checkboxSelection: true,
        suppressSorting: true,
        suppressFilter: true,
        cellClass: ['tc', 'cl_w', 'noCellFocus'],
        suppressMenu: true,
        pinned: 'left'
      },
      {
        headerName: 'ロケーション',
        field: 'locaTx',
        sort: 'asc',
        unSortIcon: true,
        cellClass: ['tl', 'cellclass'],
        width: this.getColumnWidth('locaTx', 160)
      },
      {
        headerName: '商品コード',
        field: 'itemCd',
        unSortIcon: true,
        cellClass: ['tl', 'cellclass'],
        width: this.getColumnWidth('itemCd', 140)
      },
      {
        headerName: '商品名',
        field: 'itemTx',
        unSortIcon: true,
        cellClass: ['tl', 'cellclass'],
        width: this.getColumnWidth('itemTx', 260)
      },
      {
        headerName: '単位',
        field: 'unitTx',
        unSortIcon: true,
        cellClass: ['tl', 'cellclass'],
        width: this.getColumnWidth('unitTx', 100)
      },
      {
        headerName: '在庫区分名',
        field: 'typestockTx',
        unSortIcon: true,
        cellClass: ['tl', 'cellclass'],
        width: this.getColumnWidth('typestockTx', 100)
      },
      {
        headerName: 'ロット',
        field: 'lotTx',
        unSortIcon: true,
        cellClass: ['tl', 'cellclass'],
        width: this.getColumnWidth('lotTx', 100)
      },
      {
        headerName: '期限',
        field: 'uselimitDt',
        unSortIcon: true,
        cellClass: ['tl', 'cellclass'],
        width: this.getColumnWidth('userlimitDt', 120)
      },
      {
        headerName: '在庫数',
        field: 'stockNr',
        unSortIcon: true,
        cellClass: ['tr', 'cellclass'],
        width: this.getColumnWidth('stockNr', 80),
        editable: false,
        valueFormatter: insertcomma
      },
      {
        headerName: '棚卸数',
        field: 'inventorystockNr',
        width: this.getColumnWidth('inventorystockNr', 120),
        editable: true,
        unSortIcon: true,
        cellEditor: 'numericCellEditor',
        cellStyle: { 'padding-right': '20px' },
        cellClass: (params) => {
          return this.inputCellClass(params, 'inventorystockNr');
        },
        onCellValueChanged: params => {
          this.gridEditFl[params.node.childIndex] = true;
        },
        valueFormatter: insertcomma
      }
    ];
    this.gridOptions.singleClickEdit = true;
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    this.gridHeight = window.innerHeight - config.headerMargin - config.containerButtonForthMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
    this.gridHelper.setGridOptions(this.gridOptions);
    this.viewModes = [{ id: 0, text: '全表示' }, { id: 1, text: '差異有のみ' }];
    this.viewMode = 0;
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'すべてCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv());
            }
          },
          'excelExport'
        ]
      }
    ];

    return result;
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa7011_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa7011_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      localStorage.setItem(`wa7011_${column.colId}_idx`, `${idx}`);
      idx++;
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  onResizeGrid(event) {
    this.gridHeight = window.innerHeight - config.headerMargin - config.containerButtonForthMargin;
  }

  ngAfterViewInit() {
    this.gridHelper.el = this.gridView;
    setTimeout(() => {
      this.onView();
    }, 500);
    sessionStorage.removeItem('isShowOwnerSelect');
    if (isSingleOwner) {
      this.isOwnerFixed = true;
    } else this.isOwnerFixed = false;
  }

  onView() {
    // drop down list
    this.ownerService
      .get()
      .then(outputJson => {
        this.owners = outputJson.owners;
        if (sessionStorage.getItem('ownerResult') != null && JSON.parse(sessionStorage.getItem('ownerResult')).ownerId !== undefined) {
          this.ownerId = JSON.parse(sessionStorage.getItem('ownerResult')).ownerId;
        } else {
          this.ownerId = undefined;
        }
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onSubmit(event?) {
    if (this.ownerId === undefined) {
      // this.gridOptions.api.showLoadingOverlay();
      this.errorInfo = '荷主を選択してください';
      return;
    }

    this.inventoryService
      .getStock(this.ownerId, this.viewMode)
      .then(outputJson => {
        if (outputJson.inventorystocks != null && outputJson.inventorystocks.length > 0) {

          for (var i = 0; i < outputJson.inventorystocks.length; i++)
            outputJson.inventorystocks[i][this.INVEN_RANDOM_PROP_NAME] = i;
        }

        this.rowData = outputJson.inventorystocks;
        for (let i = 0; i < this.rowData.length; i++) {
            this.rowData[i]['inventorystockNrOnLoad'] = this.rowData[i]['inventorystockNr'];
        }
        
        if (this.rowData.length > 0) {
          this.ownerId = this.rowData[0]['ownerId'];
          this.ownerCd = this.rowData[0]['ownerCd'];
          this.ownerTx = this.rowData[0]['ownerTx'];
          this.inventoryId = this.rowData[0]['inventoryId'];
          this.createDt = this.rowData[0]['createDt'];
          this.inventoryDt = this.rowData[0]['inventoryDt'];
          this.endDt = this.rowData[0]['endDt'];
          this.stinventoryId = this.rowData[0]['stinventoryId'];
          this.stinventoryTx = this.rowData[0]['stinventoryTx'];
          this.showGrid = true;
          this.gridHelper.el.nativeElement.querySelector('div.ag-spread .ag-paging-panel').style.display = 'block';
          this.working = true;

          this.invenStock = [];
          for (var i = 0; i < outputJson.inventorystocks.length; i++) {
            var item = outputJson.inventorystocks[i];
            var tmp = {};
            for (var k in item)
              tmp[k] = item[k]
            this.invenStock.push(tmp);
          }

          // outputJson.invenStock.forEach(item => {
          //   var tmp = {};
          //   for (var k in item)
          //     tmp[k] = item[k]
          //   this.invenStock.push(tmp);
          // });
          // this.gridOptions.api.hideOverlay();
        } else {
          //this.errorInfo = '棚卸データがありません。棚卸データ作成後に再検索してください';
          this.showGrid = false;
          // this.gridOptions.api.hideOverlay();
          this.gridHelper.el.nativeElement.querySelector('div.ag-spread .ag-paging-panel').style.display = 'none';
        }
      })
      .catch(error => {
        // this.gridOptions.api.hideOverlay();
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
        this.showGrid = false;
      });
  }

  updStock() {
    this.errorInfo = '';
    this.gridApi.api.stopEditing();

    const inventoryStockList = [];
    for (let i = 0; i < this.rowData.length; i++) {
      const inventoryStock = {
        inventorystockId: this.rowData[i]['inventorystockId'],
        inventorystockNr: this.rowData[i]['inventorystockNr'],
        updprogramCd: this.updprogramCd
      };
      inventoryStockList[i] = inventoryStock;
    }

    this.inventoryService
      .updateStock(this.inventoryId, inventoryStockList)
      .then(outputJson => {
        sessionStorage.setItem('SuccessInfoMessage', '棚卸データを更新しました');
        this.onSubmit();
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }
    
  commitButtonClicked() {
    if(this.working && this.showGrid){
        for (let i = 0; i < this.rowData.length; i++) {
            if(this.rowData[i]['inventorystockNr'] !== this.rowData[i]['inventorystockNrOnLoad']){
              this.errorInfo = '保存されていない修正があります。先に保存ボタンを押して保存してください。';
              return;
            }
        }
        this.modal1 = true;
        return;
    }
  }

  commit() {
    this.inventoryService
      .end(this.ownerId, this.inventoryId, this.updprogramCd)
      .then(outputJson => {
        this.modal1 = false;
        sessionStorage.setItem('SuccessInfoMessage', '完了,棚卸データを確定しました');
        this.working = false;
        setTimeout(() => {
          this.onSubmit();
        }, 3200);
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
        this.modal1 = false;
      });
  }

  cancel() {
    this.inventoryService
      .cancel(this.ownerId, this.inventoryId, this.updprogramCd)
      .then(outputJson => {
        this.modal2 = false;
        sessionStorage.setItem('SuccessInfoMessage', '完了, 棚卸データを取り消ししました');
        this.working = false;
        setTimeout(() => {
          this.onSubmit();
        }, 3200);
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
        this.modal2 = false;
      });
  }

  print(reportCd: string) {
    this.errorInfo = '';

    this.isShowSendLoading = true;
    if (!this.isEnableRightSearchButtons) return;
    if (this.ownerId === undefined) {
      this.errorInfo = '荷主を選択してください';
      this.isShowSendLoading = false;
      return;
    }
    // Reset the flag to indicate that the report has not been opened yet
    this.reportOpened = false;
    // Reset the limit counter
    this.reportTry = 0;
    this.reporttrnId = 0;

    let selectIdSet = new Set<number>();
    let selectedRows = this.gridOptions.api.getSelectedRows();
    for (let selectedRow of selectedRows) {
      selectIdSet.add(selectedRow.inventorystockId);
    }

    if (selectedRows.length === 0) {
      // this.dialogsService.info('エラー', '対象を選択して下さい');
      this.errorInfo = '対象を選択して下さい';
      this.isShowSendLoading = false;
      return;
    }

    let sortedIdSet = new Set<string>();
    this.gridOptions.api.forEachNodeAfterFilterAndSort(function (rowNode) {
      if (selectIdSet.has(rowNode.data.inventorystockId)) {
        sortedIdSet.add('' + rowNode.data.inventorystockId);
      }
    });

    // Submit the request to generate the report
    this.pdfReportService
      .postSpring(reportCd, 'WA7011', sortedIdSet)
      .then(outputJson => {
        console.log(JSON.stringify(outputJson));
        this.gridOptions.api.hideOverlay();
        const pdfFilename = outputJson.pdfFilename;
        const popup_window = window.open(environment.pdfPath + pdfFilename);
        this.url = environment.pdfPath + pdfFilename;
        try {
          popup_window.focus();
        } catch (e) {
          this.isShowRemoveModal = false;
        }
        this.onSubmit();
        this.working = false;
        this.isShowSendLoading = false;
      })
      .catch(error => {
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
        this.isShowSendLoading = false;
      });
  }

  waitResult(reporttrnId) {
    const obs = Observable.interval(1000).subscribe(() => {
      // Verify that we have not tried more than 10 times
      if (this.reportTry <= 10) {
        // Add a new try to the counter
        this.reportTry++;
        // Call the PDF report service
        this.pdfReportService
          .get(this.reporttrnId)
          .then(outputJson => {
            // If the createdFl is 0 the report has not finished so we retry again.
            // If the createdFl is 1 we get the report name and open a new window to show the PDF file.
            if (outputJson.reports[0].createdFl === 1) {
              // Cancel the Observable when success
              obs.unsubscribe();
              const url = environment.bucketUrl + '/report/' + outputJson.reports[0].reportpathTx;
              // We open a new tab to display the PDF.
              // If preferred we could get the PDF data and send the blob to the new tab instead.
              this.openReport(url);
            }
            if (outputJson.reports[0].createdFl === -1) {
              // Cancel the Observable when success
              obs.unsubscribe();
            }
          })
          .catch(error => {
            // Cancel the Observable in case of error
            obs.unsubscribe();
            console.log(this.commonService.getErrorMessage(error));
            this.errorInfo = this.commonService.getErrorMessage(error);
          });
      } else {
        // Cancel the Observable if the number of tries maxed out
        obs.unsubscribe();
        // TODO: Change the message in Japanese
        this.errorInfo = '帳票を取得できませんでした（タイムアウト）。再発する場合は管理者へ連絡してください';
      }
    });
  }

  // Open the newly generated report on a different tab/window
  openReport(url) {
    // Verify that the report has not been opened already in cases where the network response is slow
    // and we get multiple responses at the same time.
    if (this.reportOpened === false) {
      this.url = url;
      this.isShowRemoveModal = true;
      // Change the flag to indicate that the report was already opened
      this.reportOpened = true;
    }
  }
  confirmOk() {
    const popup_window = window.open(this.url);
    try {
      popup_window.focus();
    } catch (e) {
      this.isShowRemoveModal = false;
    }
  }

  changeViewMode(event) {
    this.errorInfo = '';

    this.onSubmit(event);
  }

  onFilterClear() {
    this.errorInfo = '';

    this.gridOptions.api.setFilterModel(null);
  }

  searchMenu() {
    this.errorInfo = '';

    if (this.searchOpen === true) {
      this.searchOpen = false;
    } else {
      this.searchOpen = true;
    }
  }

  clrErr() {
    this.errorInfo = '';
  }

  inputCellClass(params, field) {
    if (this.invenStock != null) {
      for (let i = 0; i < this.invenStock.length; i++) {

        if (this.invenStock[i][this.INVEN_RANDOM_PROP_NAME] == params.data[this.INVEN_RANDOM_PROP_NAME]) {

          var cls = null;
          if (params.value != this.invenStock[i][field]) {

            cls = 'txtactive';
          }
          return this._inputCellClass(params, cls);
        }
      }
    }
    return this._inputCellClass(params, null);
  }
  _inputCellClass(params, cls) {
    var defaultClss = ['tr', 'cellclass', 'editClass', 'noCellFocus'];
    if (cls == null) {
      var rowDOM = this.gridView.nativeElement.querySelectorAll('div[role="row"]');

      if (rowDOM != null) {
        rowDOM.forEach(item => {

          if (!item.hasAttribute('row'))
            return;
          var rowValue = item.getAttribute('row');
          if (rowValue !== params.node.id)
            return;

          var cells = item.querySelectorAll('.ag-cell[role="gridcell"][colId="' + params.colDef.field + '"]');//
          if (cells.length == 0)
            return;

          if (cells[0].classList.contains('txtactive'))
            cells[0].classList.remove('txtactive');
        });
      }
      return defaultClss;
    }
    defaultClss.push(cls);
    return defaultClss;
  }

  ngDoCheck() {
    if (isSingleOwner) {
      this.isOwnerFixed = true;
    } else this.isOwnerFixed = false;
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa7Inventory/wa7011/wa7011.component.ts